export enum LoaderType {
    Cicle,
    Grow
}
